/**
 * Available routes within the application.
 */
export const Routes: Record<string, string> = {
    COMPOUNDS: '/compounds',
    TARGETS: '/targets',
    DRIVERS: '/drivers',
    NOT_FOUND: '/not-found',
    BASE: '/'
}
